import FeatureSwitches from "./FeatureSwitches";
import _ from "lodash";
const featureSwitch = new FeatureSwitches();

export const options = featureSwitch.setOptions().options;

import {
  BLIND_SHIPPING,
  BORDER_TYPE,
  CANVAS_DEPTH,
  DIGITAL_PROOF,
  FLOATER_FRAME,
  HANGING_KIT,
  IMAGE_BORDER_TYPE,
  METAL_EASEL,
  MOUNTING_STUDS,
  NEXT_DAY_SHIPPING,
  NEXT_DAY_SHIPPING_PROMO,
  PAPER_TYPE,
  PRIORITY_HANDLING
} from "../constants/productOptions";

export const sortedOptions = (options) => {
  return _.sortBy(options, (option) => option.index);
};

export const largeFormatCheck = (height, width) => {
  return (height > 99 && width > 99) || height > 99 || width > 99;
};

export const filteredOptions = (pageType, options, useSku) => {
  // The removeOptions object lists all options that SHOULD NOT BE PRESENT for a particular
  // item type. If you list an item, then you do not want it to appear as an option.
  //
  // Use first word of page collectionName
  let removeOptions = {};
  if (useSku) {
    removeOptions = {
      CAN: [
        BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING,
        DIGITAL_PROOF,
        BLIND_SHIPPING,
        HANGING_KIT
      ],
      COL: [
        BORDER_TYPE,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING,
        DIGITAL_PROOF,
        BLIND_SHIPPING,
        HANGING_KIT
      ],
      // TODO: If possible, rearrange these keys in alphabetical order
      WALL: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING,
        DIGITAL_PROOF,
        BLIND_SHIPPING
      ],
      TRIP: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        DIGITAL_PROOF,
        BLIND_SHIPPING
      ],
      POST: [
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING_PROMO,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING,
        DIGITAL_PROOF,
        BLIND_SHIPPING
      ],
      METAL: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING_PROMO,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      WOOD: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING,
        NEXT_DAY_SHIPPING_PROMO,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        BLIND_SHIPPING
      ],
      PILLOW: [
        BLIND_SHIPPING,
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING,
        NEXT_DAY_SHIPPING_PROMO,
        PAPER_TYPE,
        PRIORITY_HANDLING
      ],
      MAGNET: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      TSHIRT: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        PAPER_TYPE,
        BLIND_SHIPPING
      ],
      MOUSEPAD: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        PAPER_TYPE,
        BLIND_SHIPPING
      ],
      BOTTLE: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      WATERBOTTLE: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      GLASS: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      CUTTING: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      TOTE: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      MUG: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      CAMPING: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      TUMBLER: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      PUZZLE: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      ACRYLIC: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      COASTER: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      PLAQUE: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      FOAM: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      FLEECE: [
        BLIND_SHIPPING,
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING_PROMO
      ],
      WOVEN: [
        BLIND_SHIPPING,
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING_PROMO
      ],
      PHOTOS: [
        BLIND_SHIPPING,
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING_PROMO
      ],
      PULP: [
        BLIND_SHIPPING,
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING_PROMO
      ]
    };
  } else {
    removeOptions = {
      single: [
        BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING,
        DIGITAL_PROOF,
        HANGING_KIT
      ],
      collage: [
        BORDER_TYPE,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING,
        DIGITAL_PROOF,
        HANGING_KIT
      ],
      wall: [
        BORDER_TYPE,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING,
        DIGITAL_PROOF
      ],
      triptych: [
        BORDER_TYPE,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING,
        DIGITAL_PROOF
      ],
      poster: [
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      default: [
        BLIND_SHIPPING,
        DIGITAL_PROOF,
        HANGING_KIT
      ],
      metal: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        MOUNTING_STUDS,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      wood: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING_PROMO,
        BLIND_SHIPPING
      ],
      pillow: [
        BLIND_SHIPPING,
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING_PROMO
      ],
      sticker: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        BLIND_SHIPPING,
        NEXT_DAY_SHIPPING
      ],
      magnet: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      promo: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      tshirt: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      crewneck: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      hoodie: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      polo: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      mousepad: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      bottle: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      water: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      glass: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      cutting: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      tote: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      mug: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      camping: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      tumbler: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      koozie: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      drink: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      puzzle: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      acrylic: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      coaster: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      plaque: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      ornament: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      foam: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      fleece: [
        BLIND_SHIPPING,
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING_PROMO
      ],
      woven: [
        BLIND_SHIPPING,
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING_PROMO
      ],
      photos: [
        BLIND_SHIPPING,
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        NEXT_DAY_SHIPPING,
        PAPER_TYPE,
        PRIORITY_HANDLING,
        NEXT_DAY_SHIPPING
      ],
      pulp: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      luggage: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ],
      dog: [
        BORDER_TYPE,
        CANVAS_DEPTH,
        DIGITAL_PROOF,
        FLOATER_FRAME,
        HANGING_KIT,
        IMAGE_BORDER_TYPE,
        METAL_EASEL,
        MOUNTING_STUDS,
        PAPER_TYPE,
        NEXT_DAY_SHIPPING_PROMO,
        NEXT_DAY_SHIPPING,
        BLIND_SHIPPING
      ]
    };
  }
  let optionsToRemove = removeOptions[pageType];
  // Return sorted and filtered options
  return options.filter((option) => !optionsToRemove?.includes(option.handle));
};

export const playerOptions = {
  finalObj: {
    imageHeightOriginal: 0,
    imageWidthOriginal: 0,
    nodes: {}
  },
  imageMagickObj: {
    imageHeight: 0,
    imageWidth: 0,
    verticalMov: 0,
    horizontalMov: 0,
    horizontalPos: 0,
    blacknwhite: false,
    rotate: 0
  },
  dimensions: {
    canWidth: 0,
    canHeight: 0
  },
  playerObj: {},
  objAsset: {},
  currentNode: ""
};

export const findOption = (optionHandle, options) => {
  return options.find((option) => option.handle == optionHandle);
};

export const getSelectedOption = (handle, options) => {
  return findOption(handle, options).values.find((option) => option.selected);
};

export const changeOptionToLabel = (options, optionName, label, valueSku) => {
  return options.map((option) => {
    if (option.name == optionName) {
      option.values.map((value) => {
        if (value.label == label) {
          value.selected = true;
          value.variant = option.product?.variants.find(
            (variant) => variant.sku == (valueSku || value.sku)
          );
        } else {
          value.selected = false;
        }
      });
    }
    return option;
  });
};

export const propertiesForOptions = (options) => {
  const productOptions = {};
  [
    //BLIND_SHIPPING,
    CANVAS_DEPTH,
    //DIGITAL_PROOF,
    //HANGING_KIT,
    IMAGE_BORDER_TYPE,
    //NEXT_DAY_SHIPPING,
    //NEXT_DAY_SHIPPING_PROMO
  ].forEach((productHandle) => {
    const option = findOption(productHandle, options);
    const value = option.values.find((value) => value.selected);

    productOptions[option.name] = value.value;
  });
  return productOptions;
};

export const buildCartArrayForProductOptions = (
  options,
  linkId,
  quantity = 1
) => {
  const optionsArray = [];
  _.each(options, (option) => {
    const selectedValue = option.values.find((value) => value.selected);
    if (
      selectedValue &&
      [
        //DIGITAL_PROOF,
        //NEXT_DAY_SHIPPING,
        //PRIORITY_SHIPPING,
        //NEXT_DAY_SHIPPING_PROMO
      ].includes(option.handle)
    ) {
      optionsArray.push({
        properties: { _linkId: linkId },
        id: selectedValue.variant.id,
        quantity: 1
      });
    } else if (selectedValue && selectedValue.price > 0) {
      optionsArray.push({
        properties: { _linkId: linkId },
        id: selectedValue.variant.id,
        quantity
      });
    }
  });

  return optionsArray;
};
